<template>
  <div class="grid-x site-list">
    <div class="layer" v-if="ui.refreshSSL"></div>
    <div class="cell medium-8 align-self-middle">
      <a :href="'https://'+site.url" target="_blank">{{site.url}}</a>
    </div>
    <div class="cell medium-4 text-right">
      <div class="grid-x grid-margin-x">
        <div class="cell auto text-right ssl align-self-middle">
          <span class="link" @click="refreshSSL(site)"><i class="las right-m la-sync"></i></span><span v-tooltip.auto="{content: compStatusMessage, offset: 8, delay: {hide:300}, autoHide: false}" :class="compSslStatus">SSL<i class="las" :class="compSslIcon + ' ' + compSslStatus"></i></span>
        </div>
        <div class="cell shrink">
          <a class="button warning tiny margin-bottom-0" href="#" @click="delSite(site)">Delete</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'siteListItem',
  data: function() {
    return {
      state: this.$store.state,
      ui: {
        refreshSSL: false
      }
    }
  },
  props: {
    site: Object
  },
  components: {
  },
  mounted() {
  },
  computed: {
    compSslDaysRemaining() {
      if (!this.site.checkSSLModel?.validTo) return null
      let curDate = new Date()
      let validTo = new Date(this.site.checkSSLModel.validTo)
      let daysRemaining = Math.floor((validTo - curDate) / (24*60*60*1000))
      return daysRemaining
    },
    compSslStatus() {
      if (!this.site.checkSSLModel?.id) return 'nostatus'
      if (!this.site.checkSSLModel.valid) return 'red'
      if (this.compSslDaysRemaining < 30) return 'yellow'
      if (this.compSslDaysRemaining >= 30) return 'green'
      return false
    },
    compSslIcon() {
      if (this.compSslStatus === 'green') return 'la-check'
      if (this.compSslStatus === 'yellow') return 'la-check'
      if (this.compSslStatus === 'red') return 'la-exclamation-triangle'
      if (this.compSslStatus === 'nostatus') return 'la-question-circle'
      return 'la-question-circle'
    },
    compStatusMessage() {
      if (this.compSslDaysRemaining) return this.compSslDaysRemaining + ' days remaining'
      if (this.site.checkSSLModel?.error) return this.site.checkSSLModel.error
      if (this.compSslStatus === 'nostatus') return 'Not checked yet'
      return ''
    }
  },
  methods: {
    async refreshSSL(site) {
      this.ui.refreshSSL = true
      try {
        await this.$store.refreshSSL(site)
        
        //siteInState = result
        
      } catch(err) {
        console.log(err)
      }
      this.ui.refreshSSL = false
    },
    async delSite(site) {
      this.$confirm("Wirklich löschen?").then(async () => {
        try {
          await this.$store.delSite(site)
        } catch(err) {
          console.log(err)
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.link {
  cursor: pointer
}
.site-list {
  position: relative
}
.layer {
  position: absolute
  top:0
  left:0
  width:100%
  height:100%
  background-color: rgba(0,0,0,0.3)
  z-index:30
}
.ssl {
  font-size: 0.8em
  .green {
    color: green
  }
  .yellow {
    color: yellow
  }
  .red {
    color: red
  }
  i {
    font-size:1.5em
    margin-left:5px
    position: relative
    bottom: -1px
  }
  .right-m {
    margin-right:5px
  }
}
</style>

